<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="/"><i class="icon-home"></i></a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ translations.forgotPassword }}
          </li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <div class="page-header">
      <div class="container">
        <h1>{{ translations.forgotPassword }}</h1>
      </div>
      <!-- End .container -->
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <section>
            <div>

              <div class="panel card-sign">
                <div class="card-title-sign mt-3 text-end">
                  <h2 class="title text-uppercase font-weight-bold">
                    <i class="bx bx-user-circle me-1 text-6 position-relative top-5"></i>
                    {{ translations.passwordRecovery }}
                  </h2>
                </div>
                <div>
                  <div class="alert alert-info">
                    <p class="m-0">
                      {{ translations.enterYourEmailAddressBelowAndWellSendYouInstructions }}
                    </p>
                  </div>

                  <form @submit.prevent="forgotPassword">
                    <div class="form-group mb-0">
                      <div class="input-group">
                        <input
                          name="email"
                          type="email"
                          placeholder="E-mail"
                          class="form-control form-control-lg"
                          autocomplete="off"
                          v-model="email"
                          required
                        />
                        <button class="btn btn-primary btn-lg" type="submit">
                          {{ translations.reset }}!
                        </button>
                      </div>
                    </div>

                    <p class="text-center mt-3">
                      {{ translations.remembered }}?
                      <router-link exact :to="{ name: 'Login' }">
                        {{ translations.logIn }}!
                      </router-link>
                    </p>
                  </form>
                </div>
              </div>

              <p class="text-center text-muted mt-3 mb-3">
                Eurosan B2B. &copy; {{ currentYear }}. {{translations.allRightsReserved}}
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { translations } from '@/mixins';

export default {
  name: 'ForgotPassword',
  mixins: [translations],
  data() {
    return {
      email: '',
      submitted: false,
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    forgotPassword() {
      api.forgotPassword(this.email).then((response) => {
        this.$toast.info(response.data.info);
        this.submitted = true;
        this.$router.push({ name: 'Login' });
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
  },
};
</script>
